import { $platformCode } from "../../common"
export function getHomePageFrame () {
  return this.fetch({
    url: 'mall-server/api/topic/v1/index',
    platformCode: $platformCode,
    params: {
      deliveryType: 1
    }
  })
}
export function getSpecialConfig (data) {
  return this.fetch({
    url: 'mall-server/api/topic/v1/special',
    platformCode: $platformCode,
    params: {
      dataType: 2,
      ...data
    }
  })
}
// 获取海报数据
export function getTopicPoster (params) {
  return this.fetch({
    url: 'mall-server/api/topic/v1/poster',
    platformCode: $platformCode,
    header: {
      tenantId: $platformCode
    },
    params
  })
}

// 获取专题数据
export function getTopicSpecial (params) {
  return this.fetch({
    url: 'mall-server/api/topic/v1/special',
    platformCode: true,
    header: {
      tenantId: $platformCode
    },
    params
  })
}

// 获取弹窗内容
export function getPopUp(params) {
  return this.fetch({
    method: 'GET',
    platformCode: true,
    url: 'mall-server/api/act/popup/v1/getPopupInfo',
    params
  })
}
// 修改弹窗状态
export function savePopUpLog(params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/act/popup/v1/savePopupLog',
    params
  })
}

// 客服中心
export function getLive (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/common/v1/kfUrl',
    params
  })
}
